import React, { useEffect, useMemo, useState } from 'react';
import { Card, Layout } from "antd";
import { MDBCol, MDBRow } from "mdbreact";
import { Text } from "react-font";
import {
	Button,
	CrossIcon,
	Dialog, EditIcon,
	Heading,
	HelpIcon,
	IconButton,
	Pane,
	SelectMenu,
	Tooltip,
	TrashIcon
} from "evergreen-ui";
import { message, Table } from 'antd';
import Firebase from "../../Firebase/Firebase";
import 'jspdf-autotable';
import FireFetch from "../../Firebase/FireFetch";
import { TableExport } from "tableexport";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import moment from "moment";
import TableActionMenu from "../../Common/TableActionMenu";
import AddPriority from "../../Modals/Priorities/AddPriority";
import EditPriority from "../../Modals/Priorities/EditPriority";
import { useAuth } from "../../AuthContext/AuthContext";
import { getOrganizationName, useMergedListVals } from "../../Firebase/dataCompat";
import {
	getPriorityEndpoint,
	normalizePriorityRecord,
} from "./priorityCompat";


const columns = [
	{
		title: 'Community',
		dataIndex: 'community',
		key: 'community',
		sorter: (a, b) => a.community && a.community.localeCompare(b.community),
	},
	{
		title: 'Initiative',
		dataIndex: 'initiative',
		key: 'initiative',
		sorter: (a, b) => a.initiative && a.initiative.localeCompare(b.initiative),
	},
	{
		title: 'Priority Level',
		dataIndex: 'level',
		key: 'level',
		sorter: (a, b) => String(a.level ?? "").localeCompare(String(b.level ?? "")),
	},
	{
		title: 'Country',
		dataIndex: 'country',
		key: 'country',
		sorter: (a, b) => a.country && a.country.localeCompare(b.country),
		responsive: ["sm"]
	},
	{
		title: 'Organization',
		dataIndex: 'org',
		key: 'org',
		sorter: (a, b) => a.org && a.org.localeCompare(b.org),
		responsive: ["sm"]
	},
	{
		title: 'Start Date',
		key: 'start',
		dataIndex: 'start',
		sorter: (a, b) => moment(a.start, "DD/MMM/YYYY").diff(moment(b.start, "DD/MMM/YYYY HH:MM")),
		responsive: ["sm"]

	}, {
		title: 'End Date',
		key: 'end',
		dataIndex: 'end',
		sorter: (a, b) => moment(a.end, "DD/MMM/YYYY").diff(moment(b.end, "DD/MMM/YYYY HH:MM")),
		responsive: ["sm"]

	},
	{
		title: 'Action',
		key: 'action',
		dataIndex: 'action',

	},
];

var db = getDatabase(Firebase);
const auth = getAuth(Firebase);
const Priorities = () => {
	const { canAccessModule } = useAuth();
	const canCreatePriority = canAccessModule("COMMUNITY_PRIORITIES", "create");
	const canUpdatePriority = canAccessModule("COMMUNITY_PRIORITIES", "update");
	const canDeletePriority = canAccessModule("COMMUNITY_PRIORITIES", "delete");

	const [createModal, setCreateModal] = useState(false);
	const [checkedData, setCheckedData] = useState(false);
	const [eventsData, setEventsData] = useState([]);
	const [dataArray, setDataArray] = useState([]);
	const [mergedPriorities, prioritiesLoading] = useMergedListVals(
		"talmidsdb/priorities",
		"talmidsdb/Priorities",
		"talmidsdb/communityPlanning/priorities"
	);
	const [organizationArray, organizationsLoading] = useListVals(ref(db, "talmidsdb/organisations"));
	const [communityArray, communitiesLoading] = useListVals(ref(db, "talmidsdb/communities"));
	const [initiatives, initiativesLoading] = useListVals(ref(db, "talmidsdb/initiatives"));
	const priorityArray = useMemo(
		() => mergedPriorities.map(normalizePriorityRecord),
		[mergedPriorities]
	);
	const initiativeArray = useMemo(() => [
		...initiatives.map((item) => ({
			...item,
			label: item.initiative || item.title || item.label,
			value: item.initiativeID || item.id || item.value,
		})),
		{ label: "All", value: "All" },
	].sort((a, b) => String(a.label || "").localeCompare(String(b.label || ""))), [initiatives]);
	const loading = prioritiesLoading || organizationsLoading || communitiesLoading || initiativesLoading;
	const [selectedFilter, setSelectedFilter] = useState(null);
	const [priority, setPriority] = useState(null);
	const [editModal, setEditModal] = useState(false);

	const callback = (data) => {
		setCheckedData(data);
	}

	useEffect(() => {
		onAuthStateChanged(auth, function (user) {
			if (user) {
				//var feedbackOption = props.location.option;
				//setOption(feedbackOption);
				if (priorityArray) {

					var tempArray = [];
					priorityArray.map((item, index) => {
						const community = communityArray.find((x) => x.communityID === item.communityID || x.id === item.communityID);
						const organizationId =
							item.organisationID ||
							item.orgID ||
							community?.orgID ||
							community?.organisationID ||
							"";
						tempArray.push({
							key: index + 1,
							level: item.priority,
							priority: item.priorityName,
							community: community?.name,
							initiative: initiatives.find(x => x.initiativeID === item.initiativeID || x.id === item.initiativeID) ?
								(initiatives.find(x => x.initiativeID === item.initiativeID || x.id === item.initiativeID).initiative || initiatives.find(x => x.initiativeID === item.initiativeID || x.id === item.initiativeID).title) : item.initiativeID,
							country: community?.countryID?.split('-')[0],
							org: getOrganizationName(organizationArray, organizationId, "Unknown organization"),
							start: moment(item.startDate, "YYYY-MM-DD").format("DD/MMM/YYYY"),
							end: moment(item.endDate, "YYYY-MM-DD").format("DD/MMM/YYYY"),
							action: (
								<TableActionMenu
									items={[
										canUpdatePriority && {
											key: "edit",
											label: "Edit",
											onClick: () => {
												setPriority(item);
												setEditModal(true);
											},
										},
										canDeletePriority && {
											key: "delete",
											label: "Delete",
											danger: true,
											onClick: () => {
												if (!canDeletePriority) {
													message.error("You do not have permission to delete priorities.");
													return;
												}

												if (confirm("Are you sure you want to delete Priority?")) {
													FireFetch.DeleteFromDB(getPriorityEndpoint(item), item.priorityID || item.id).then((result) => {
														if (result === "success") {
															FireFetch.addLog("priorities", item.priorityID || item.id, "Delete");
															message.success("Priority deleted");
														} else {
															message.error("Unable to delete");
														}
													}).catch(() => {
														message.error("Unable to delete");
													});
												}
											},
										},
									]}
								/>
							)
						});
					});
					setEventsData(tempArray);
					setDataArray(tempArray);
				}
			} else {
				// No user is signed in.
				window.location.href = "/login";
			}
		});
	}, [communityArray, initiatives, organizationArray, priorityArray, canUpdatePriority, canDeletePriority]);

	const handleFilter = (filterText) => {
		if (filterText === "All") {
			setEventsData(dataArray);
		} else {
			const filteredEvents = dataArray.filter(({ initiative }) => {
				//category = category.toLowerCase();
				return initiative?.includes(filterText);
			});

			setEventsData(filteredEvents);

		}

	}



	const exportXL = (title) => {
		var table = TableExport(document.getElementById("dataTable"), {
			filename: title,
			exportButtons: false,
			sheetname: title,
		});
		var exportData = table.getExportData();

		var dataObjects = eventsData;
		dataObjects.map((item) => {
			delete item.action;
		})

		const csvData = FireFetch.jsonToCsv(eventsData)
		var csv = exportData.dataTable.csv;
		table.export2file(csvData, csv.mimeType, csv.filename, csv.fileExtension, csv.merges, csv.RTL, csv.sheetname);

	}

	return (
		<div className="font-Nunito">
			<Dialog
				isShown={createModal}
				title="Create New Priority"
				onCloseComplete={() => { setCreateModal(false) }}
				confirmLabel="Create"
				hasFooter={false}
				shouldCloseOnOverlayClick={false}
			>
				<AddPriority modal={setCreateModal} />
			</Dialog>
			<Dialog
				isShown={editModal}
				title="Edit Priority"
				onCloseComplete={() => { setEditModal(false) }}
				confirmLabel="Edit"
				hasFooter={false}
				shouldCloseOnOverlayClick={false}
			>
				<EditPriority modal={setEditModal} priority={priority} />
			</Dialog>
			<div className="d-flex justify-content-center align-items-center pt-4 mt-4">
				<MDBRow className="w-100">
					<MDBCol md={12}>
						<Card className="w-100">
							<MDBRow>
								<MDBCol md={12}>
									<div className="text-left">
										<div className="d-flex flex-row justify-content-between">
											<div className="d-inline">
												<h5 className="font-weight-bold" style={{ color: '#51195D' }}>
													<Text family='Nunito'>
														Community Priorities
													</Text>
												</h5>
											</div>
											<div className="d-flex flex-row">
												<SelectMenu
													title="Choose Initiative"
													titleView={({ close, title, headerHeight }) => {
														return (
															<Pane
																display="flex"
																alignItems="center"
																borderBottom="default"
																padding={8}
																height={headerHeight}
																boxSizing="border-box"
															>
																<Pane flex="1" display="flex" alignItems="center">
																	<Heading size={400}>{title}</Heading>
																	<Tooltip content="Pick one of the options below">
																		<HelpIcon size={12} marginLeft={4} />
																	</Tooltip>
																</Pane>
																<IconButton icon={CrossIcon} appearance="minimal" height={24} onClick={close} />
															</Pane>
														)
													}}
													options={initiativeArray}
													selected={selectedFilter}
													closeOnSelect={true}
													onSelect={item => { setSelectedFilter(item.value); handleFilter(item.label) }}
												>
													<Button color={"primary"} className="mx-4">{selectedFilter || 'Initiative'}</Button>
												</SelectMenu>
												<Button intent="primary" appearance="primary"
													onClick={() => {
														//exportToPDF("Something");
														exportXL("Priorities");
													}} className="d-inline float-right">
													Print
												</Button>
												{canCreatePriority && (
													<Button appearance="primary"
														className="mx-2" onClick={() => { setCreateModal(true) }}>
														New Priority
													</Button>
												)}
											</div>
										</div>
									</div>
								</MDBCol>
							</MDBRow>
						</Card>
						<Card id="tableDiv">
							<Table id="dataTable" className="custom-table"
								loading={loading}
								pagination={{ defaultPageSize: 100, showSizeChanger: true, pageSizeOptions: ['20', '50', '100'] }}
								style={{ overflow: "auto" }} columns={columns} dataSource={eventsData} />
						</Card>

					</MDBCol>
				</MDBRow>
			</div>
		</div>
	);
}

export default Priorities;
